import CookieBanner from '../components/site/cookieBanner';

const classes = {
    siteSearchForm: ".js-search-form",
    tabs: ".js-tabs",
    forms: ".js-form",
    overlayMain: ".js-overlay--blur",
    nav: ".js-nav--sub",
    passwordReveal: ".js-reveal-pw",
    glide: ".js-glide",
    ratio: ".js-ratio",
    headBanner: ".js-head-ban",
    fieldReset: ".js-reset-fld",
    lazyLoadVideos: ".js-vid-lazy"
};

document.addEventListener("DOMContentLoaded", function (event:any) {
    if (document.querySelector(classes.siteSearchForm)) {
        import('../components/site/siteSearch').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.tabs)) {
        import('../components/widgets/tabs').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.overlayMain)) {
        import('../components/site/overlayBlur').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.forms)) {
        import('../components/widgets/forms').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.nav)) {
        import('../components/site/nav').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.passwordReveal)) {
        import('../components/site/passwordReveal').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.glide)) {
        import('../components/widgets/carousel').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.ratio)) {
        import('../components/site/ratio').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.headBanner)) {
        import('../components/widgets/head-banner').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.fieldReset)) {
        import('../components/site/fieldReset').then(md => {
            md.default.init();
        });
    }

    if (document.querySelector(classes.lazyLoadVideos)) {
        import('../components/site/lazyLoadVideos').then(md => {
            md.default.init();
        });
    }

    CookieBanner.init();
});